var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteGroup3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 228,
    viewBox: "0 0 220 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_369_6185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2624 166.025C27.2624 166.025 52.0714 167.112 101.622 171.77C101.622 171.77 163.996 176.777 172.717 175.772C172.717 175.772 171.682 61.4842 176.459 38.0174L31.0365 27.0293C31.0365 27.0293 24.5378 129.105 27.2607 166.024L27.2624 166.025Z",
    fill: "url(#paint0_linear_369_6185)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_369_6185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4414 64.3638L45.7997 179.052C45.7997 179.052 46.6451 194.248 57.7866 190.38C57.7866 190.38 65.9809 184.883 64.1137 174.885C64.1137 174.885 150.742 180.556 197.137 169.942L165.217 30.4039L19.4414 64.3638Z",
    fill: "url(#paint1_linear_369_6185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.417 189.737C50.417 189.737 63.6233 196.812 64.1159 174.886C64.1159 174.886 162.925 179.507 202.324 168.277C202.324 168.277 202.708 173.238 198.811 175.564C198.811 175.564 128.652 186.583 84.7937 190.224C84.7937 190.224 53.4591 193.838 50.4175 189.739L50.417 189.737Z",
    fill: "url(#paint2_linear_369_6185)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_369_6185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2334 155.736C42.2334 155.736 66.9763 157.848 116.292 164.55C116.292 164.55 178.406 172.129 187.161 171.486C187.161 171.486 190.85 57.2531 196.593 34.0037L51.7481 17.0156C51.7481 17.0156 41.0368 118.735 42.2317 155.736L42.2334 155.736Z",
    fill: "url(#paint3_linear_369_6185)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.531 88.7927C128.893 85.9351 127.11 83.4968 123.94 82.6051C123.798 82.5846 123.764 82.4828 123.771 82.4353C123.778 82.3878 123.778 82.3878 123.941 82.2657C127.281 80.9513 129.639 78.3804 130.028 75.6721C130.246 74.1518 129.86 72.787 128.897 71.7273C127.914 70.4708 126.15 69.587 124.011 69.2799C121.113 68.8636 117.847 69.6554 114.662 71.574C113.576 72.0484 112.645 73.127 112.488 74.2198C112.379 74.98 112.575 75.6386 113.084 76.1481C113.416 76.5353 113.776 76.7324 114.204 76.7938C115.391 76.9644 117.014 76.1307 119.269 74.2724C120.37 73.703 121.714 73.4597 122.854 73.6235C123.757 73.7531 124.476 74.1474 124.924 74.7451C125.114 75.1118 125.242 75.5667 125.181 75.9943C124.901 77.9423 122.137 79.9699 118.817 80.4629C117.439 80.6045 116.318 81.6558 116.134 82.9386C115.997 83.8889 116.383 84.5748 117.144 84.684C117.191 84.6908 117.388 84.6706 117.436 84.6774C118.366 84.617 119.133 84.6787 119.703 84.7606C122.221 85.1222 123.774 86.4607 123.583 88.1305C123.413 89.3183 122.59 90.3155 121.076 91.0679C119.555 91.8677 118.014 92.1313 116.391 91.9468L116.249 91.9263C114.158 91.6261 113.087 90.3083 113.204 88.143C113.3 87.1384 112.866 86.4457 112.058 86.3297C110.965 86.1727 109.682 87.0067 109.47 88.1402C109.191 89.0699 109.096 89.3957 109.048 89.7283C108.537 93.2917 110.917 95.6219 115.526 96.2838C118.669 96.6867 121.554 96.1798 124.148 94.6612C126.736 93.1901 128.176 91.2633 128.511 88.9352L128.531 88.7927Z",
    fill: "#424A52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.109 123.286C100.441 122.618 99.5865 121.54 98.5529 120.001C97.4925 118.457 96.8403 117.491 96.5428 117.093C97.1579 116.609 97.7234 116.09 99.0761 114.839C99.9244 114.06 100.551 113.496 100.952 113.171C101.35 112.874 101.69 112.595 102.018 112.397C102.136 112.332 102.431 112.184 102.87 111.974C103.305 111.791 103.527 111.577 103.562 111.337L103.569 111.283C103.642 110.775 103.161 110.325 102.52 110.232C102.066 110.167 101.558 110.285 101.107 110.575C100.656 110.865 100.136 111.254 99.5786 111.719C99.017 112.211 98.1993 112.967 97.1523 113.989C95.8836 115.226 95.5092 115.554 95.1462 115.802C94.963 115.748 94.9401 115.718 94.8599 115.706C94.2185 115.614 93.5652 116.175 93.3469 116.934C93.9264 113.09 94.298 111.452 94.6385 110.601C94.6921 110.417 94.7686 110.265 94.7955 110.078C94.8876 109.436 94.4985 108.917 93.8571 108.825C93.3493 108.752 92.826 108.976 92.566 109.457C92.4207 109.709 92.2522 110.312 92.0873 111.271C91.8957 112.225 91.6079 114.039 91.2202 116.738C90.9554 118.582 90.7635 119.918 90.6216 120.716C90.4797 121.514 90.3608 122.152 90.2612 122.656L90.2535 122.709C90.1767 123.244 90.5696 123.737 91.1042 123.813C91.6119 123.886 92.0131 123.562 92.3038 122.867C92.4224 122.612 92.545 122.138 92.6753 121.42C92.8019 120.729 92.9899 119.42 93.2663 117.496C93.3156 117.912 93.4987 118.156 93.8996 118.214C94.1134 118.245 94.4457 118.211 94.82 118.073C95.2014 118.646 95.5637 119.162 96.4256 120.568C97.2417 121.913 97.8672 122.875 98.3288 123.46C98.7637 124.041 99.2444 124.492 99.7138 124.832C100.008 125.065 100.344 125.195 100.691 125.245C101.199 125.318 101.6 125.184 101.768 124.963C101.864 124.868 101.879 124.761 101.894 124.654C101.944 124.307 101.689 123.806 101.109 123.286Z",
    fill: "#424A52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.77 121.332C108.851 121.343 108.904 121.351 108.988 121.336C111.146 121.127 112.918 120.564 114.282 119.614C115.642 118.691 116.406 117.546 116.594 116.236C116.759 115.087 116.386 114.079 115.451 113.181C114.512 112.309 113.257 111.747 111.733 111.528C110.985 111.421 110.195 111.417 109.4 111.439C109.24 111.225 109.011 111.11 108.69 111.064C108.156 110.987 107.629 111.239 107.35 111.663C107.35 111.663 107.292 111.682 107.266 111.678C106.846 111.754 106.616 112.021 106.559 112.422C106.513 112.743 106.65 113.117 106.917 113.346C106.802 113.957 106.695 114.514 106.46 116.145L105.923 119.886C105.574 122.318 105.298 123.67 105.011 124.72L104.995 124.827C104.922 125.334 105.353 125.751 105.915 125.832C106.449 125.908 106.9 125.618 107.168 125.084C107.393 124.462 107.604 123.374 107.931 121.102C108.106 121.209 108.289 121.263 108.583 121.305L108.77 121.332ZM108.504 119.575C108.287 119.571 108.203 119.586 108.119 119.602L108.173 119.227C108.207 118.987 108.261 118.613 108.315 118.048L108.522 116.604C108.748 115.028 108.917 114.043 109.132 113.31C109.934 113.234 110.693 113.261 111.335 113.353C113.446 113.657 114.553 114.688 114.357 116.051C114.073 117.838 111.857 119.211 108.504 119.575Z",
    fill: "#424A52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.613 126.824C120.69 126.481 120.82 125.954 120.951 125.236C121.081 124.518 121.261 123.262 121.545 121.475C121.891 119.261 122.171 117.692 122.324 116.814C122.477 115.936 122.627 115.275 122.768 114.859C122.83 114.622 122.876 114.493 122.879 114.466L122.891 114.386C123.014 113.531 122.609 112.927 121.968 112.835C121.46 112.762 121.013 113.025 120.753 113.506C120.444 114.143 120.033 116.239 119.454 120.275L119.377 120.809C119.319 121.21 119.25 121.691 119.166 122.47L118.74 125.437C118.667 125.945 118.624 126.239 118.563 126.475L118.559 126.502C118.448 127.277 118.803 127.846 119.337 127.923C119.898 128.004 120.422 127.588 120.613 126.824Z",
    fill: "#424A52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.335 115.877C128.185 116.919 127.333 117.915 126.038 118.575C125.916 118.666 125.874 118.769 125.858 118.876C125.812 119.197 126.026 119.419 126.427 119.476C126.721 119.518 127.057 119.458 127.382 119.286C129.112 118.443 130.228 116.94 130.478 115.203C130.712 113.572 129.949 112.235 128.773 112.066C127.891 111.94 127.043 112.527 126.936 113.276L126.92 113.382C126.92 113.573 127.012 113.696 127.424 114.055C128.217 114.796 128.427 115.235 128.335 115.877Z",
    fill: "#424A52"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.978 128.8C138.566 128.312 138.907 127.651 139.01 126.93L139.018 126.876C139.106 126.262 138.973 125.67 138.588 125.123C138.199 124.604 137.336 123.962 136.023 123.228C134.207 122.203 133.909 121.806 133.99 121.244C134.086 120.576 134.796 119.996 135.766 119.89C136.072 119.852 136.285 119.883 136.526 119.917C136.873 119.967 137.186 120.067 137.916 120.308C138.511 120.53 138.721 120.587 138.935 120.618L139.095 120.641C139.527 120.676 139.882 120.29 139.959 119.756L139.97 119.676C140.009 119.217 139.54 118.686 138.784 118.441C138.394 118.304 138.028 118.196 137.6 118.135C136.104 117.92 134.511 118.182 133.457 118.877C132.605 119.491 132.112 120.265 131.947 121.224L131.943 121.25C131.855 121.865 131.992 122.43 132.358 122.919C132.72 123.435 133.51 124.012 134.751 124.681C136.598 125.683 136.915 126.138 136.822 126.779C136.765 127.18 136.532 127.474 136.169 127.722C135.493 128.061 134.496 128.164 133.347 127.999C132.946 127.941 132.579 127.834 132.236 127.757C131.824 127.589 131.484 127.485 131.163 127.439C130.625 127.389 130.136 127.756 130.063 128.263C129.998 128.718 130.322 129.119 130.948 129.318C131.799 129.658 132.589 129.854 133.311 129.957C135.235 130.234 136.958 129.826 137.978 128.8Z",
    fill: "#424A52"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_369_6185",
    x: 10.594,
    y: 27.0312,
    width: 181.865,
    height: 184.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_369_6185"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0.368627 0 0 0 0 0.458824 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_6185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_369_6185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_369_6185",
    x: 3.44141,
    y: 30.4023,
    width: 214.893,
    height: 197.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_369_6185"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0.368627 0 0 0 0 0.458824 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_6185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_369_6185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_369_6185",
    x: 26.1387,
    y: 17.0156,
    width: 186.454,
    height: 190.508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_369_6185"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0.368627 0 0 0 0 0.458824 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_6185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_369_6185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_369_6185",
    x1: 103.017,
    y1: 28.9847,
    x2: 99.0763,
    y2: 174.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FAF3B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_369_6185",
    x1: 85.4079,
    y1: 43.1639,
    x2: 134.591,
    y2: 196.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EB9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FAF3B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_369_6185",
    x1: 119.342,
    y1: 157.138,
    x2: 132.149,
    y2: 196.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1E788"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_369_6185",
    x1: 123.586,
    y1: 21.9438,
    x2: 113.654,
    y2: 166.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FAF3B6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteGroup3);
export default __webpack_public_path__ + "static/media/note-group-3.19fa66e2e445953864a5fa6fdc5cf1ea.svg";
export { ForwardRef as ReactComponent };